import * as Service from 'types/service';
import { ServiceStateAppStrict, ServiceStateStrict } from 'state/service/app';
import { getNonAppState } from 'utils/service/localStorageUtils';
import ServerConnectionState from 'constants/service/serverConnectionState';

const defaultCoreState: ServiceStateAppStrict = {
  availableTableTags: {},
  parties: {},
  partyIdToTableId: {},
  tables: {},
  serverIdToPartyIds: {},
  businessTag: {},
  patronIdToPartyIds: {},
  handleDuplicateAddParty: false,
};

const defaultHistoryState = {
  items: [],
  isVisible: false,
  isLoading: false,
  serverHasMoreHistory: false,
  earliestServerId: -1,
};

const defaultAppState: ServiceStateStrict = {
  app: defaultCoreState,
  currentTopic: {
    everConnected: false,
    selectedBusiness: {
      id: -1,
      roles: [],
      name: '',
      businessGroupId: -1,
      timeZone: '',
      currencyCode: '',
      emailLogoUrl: '',
      hasPosIntegration: false,
      locale: '',
    },
    serviceDate: '',
  },
  communicator: {
    lastAcknowledgedState: defaultCoreState,
    latestServerId: 0,
    nextInternalId: 0,
    messagePendingResponse: null,
    messagesToSend: [],
    protocolErrorDetected: false,
  },
  decodeError: null, // maybe String
  error: null, // maybe String
  history: defaultHistoryState,
  historyToggledOn: false,
  isReadOnly: false,
  serverConnectionState: ServerConnectionState.Connecting,
  nextInternalHistoryId: 0,
};

interface StoredState {
  communicators: {
    [topic: string]: Service.Communicator;
  };
  currentTopic?: Service.Topic;
  legacyCommunicator?: Service.Communicator;
  isReadOnly: boolean;
}

export function getStoredState(): StoredState {
  const { communicators = {}, currentTopic, isReadOnly, legacyCommunicator } = getNonAppState();
  return {
    communicators,
    currentTopic,
    isReadOnly: !!isReadOnly,
    legacyCommunicator,
  };
}

export default defaultAppState;
